// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"8c13ccdb","42":"4027a3fd","142":"b62da527","171":"1452d84e","252":"6216fcc9","441":"6f58dbc3","507":"2ce9fb97","686":"22b37bfa","808":"6cdb9616","923":"59042399"}[chunkId] + ".chunk.js";
};